module.exports = __webpack_public_path__ + "static/media/Email.37f15439.svg";